export default __webpack_public_path__ + "0442e2d40fe13c717e7c354aaaf3b2cb.png";